export default "__VITE_ASSET__DyUmEJRR__"